export const NavigationInternalPagesEnum = {
  Home: {
    key: "1",
    value: "/home/self-service",
  },
  Profile: {
    key: "2",
    value: "/home/shared-resume",
  },
  Jobs: {
    key: "3",
    value: "/home/jobs",
    min: 1,
  },
  Applications: {
    key: "4",
    value: "/home/job-requisition",
    min: 1,
  },
  Interviews: {
    key: "5",
    value: "/home/self-service",
    isScrollToEnd: true,
    min: 1,
  },
};
